module.exports = __webpack_public_path__ + "static/img/blastmini.96f9860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purifiers/blastmini.jpg
// module id = Y+nE
// module chunks = 1